import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_QUEUE_DEPTH_ACTION_TYPE } from '../actions/queueDepth.actions';

const initialState = null;

const queueDepthReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_QUEUE_DEPTH_ACTION_TYPE.SET_QUEUE_DEPTH:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default queueDepthReducer;
